import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { ApiService } from 'src/app/services/api.service';
import { formatDate } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-slot-selection-reschedule',
  templateUrl: './slot-selection-reschedule.component.html',
  styleUrls: ['./slot-selection-reschedule.component.scss']
})
export class SlotSelectionRescheduleComponent {

  @Input() datesToHighlight: any;
  @Input() slots: any;
  @Input() slotCheckCount: any;
  @Input() countryId: any;
  @Input() completeReschedule: any;
  @Input() isChild = false;
  @Input() bookingData: any;
  @Input() applicantId: any;
  @Input() isLoading = false;
  @Input() doctorId: any;
  @Input() doctorBranchId: any;
  @Input() patientId: any;
  @Output() stepperNextEvent = new EventEmitter<any>();
  @ViewChild('myCalendar') myCalendar: any;
  selected: any;
  activeDate: any;
  startDate: any;
  isSlotsAvailable = true;
  isSlotsLoaded = true;
  loaderSlots = [1, 2, 3, 4, 5];
  storedData: any;
  specificRescheduleData: any;
  isRescheduledCompleted = false;
  rescheduleResponse: any;
  // patientId: any;
  isRevisit: any;
  constructor(private http: HttpClient, private apiService: ApiService, private renderer: Renderer2, private authService: AuthService, private storage: StorageService, private snackBar: MatSnackBar, private router: Router, private spinner: NgxSpinnerService) {
    this.apiService.isSlotsLoaded.subscribe((data: any) => {
      this.isSlotsLoaded = data;
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    const date = cellDate;
    const highlightDate = this.datesToHighlight
      .map((strDate: any) => new Date(strDate))
      .some((d: any) => d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear());
      
    this.startDate = new Date(this.datesToHighlight[0]);
    this.selected = this.startDate;
    return highlightDate ? 'special-date' : '';
  };


  async onSelected(date: any) {
    let formattedDate = formatDate(date, 'yyyy-MM-dd', 'en-US', '+0530');
    this.getSlots(formattedDate);
  }

  getSlots(date: any) {
    this.apiService.isSlotsLoaded.next(false);
    this.apiService.getSlotsByDate(date, this.isChild, this.doctorId, this.doctorBranchId, this.patientId, this.isRevisit).subscribe({
      next: (data: any) => {
        if (data.success == true) {
          //sorting by date and filtering by booking start and booking end date
          let currentDate = new Date();
          let slotData = data["data"].sort((firstEl: any, secondEl: any) => Date.parse(firstEl.start_time) - Date.parse(secondEl.start_time)).filter(
            (element: any) => currentDate >= new Date(element.time_limits.booking_start_time) && currentDate <= new Date(element.time_limits.booking_end_time)
          );
          slotData.forEach((element: any, index: number) => {
            if (this.slotCheckCount <= +element.available_slot_count) {
              slotData[index].slotsLimited = false;
            } else {
              slotData[index].slotsLimited = true;
            }
          });
          this.apiService.slots.next(slotData);
          this.apiService.slots.subscribe((data: any) => {
            this.slots = data;
            if (this.slots.length > 0) {
              this.isSlotsAvailable = true;
            } else {
              this.isSlotsAvailable = false;
            }
            return this.slots;
          });
        } else {
          this.apiService.slots.next([]);
          this.isSlotsAvailable = false;
        }
      },

      error: (err: any) => {
        this.isSlotsAvailable = false;
        this.apiService.slots.next([]);
        this.apiService.isSlotsLoaded.next(true);
      },
      complete: () => {
        this.apiService.isSlotsLoaded.next(true);
      }
    });

  }

  monthSelected(event: any) {
    const monthCount = event.getMonth() + 1;
    this.getMonthSlots(monthCount);
  }

  getMonthSlots(month: any) {
    this.apiService.getMonthSlots(month, this.isChild, this.doctorId, this.doctorBranchId).then((data: any) => {
      if (data.success == true) {
        this.apiService.monthSlots.next(data["data"].date);
        this.apiService.monthSlots.subscribe((data: any) => {
          this.datesToHighlight = data;
          this.myCalendar.updateTodaysDate();          
        });
      }else {
      }
    },
    (error) => {
    }
  );
  }

  slotRegistration(slot: any) {
    const bookingStartTime = this.bookingData.slot.start_time;
    const slotStartTime = slot.start_time;

    if(bookingStartTime === slotStartTime) {
      this.snackBar.open('The selected slot time is the same as your current booking time. Please choose a different slot to proceed with rescheduling.', 'Close', {
        // duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'error-snackbar'
      });
    }else {
      this.storedData = {
        booking_id: this.bookingData.id,
        slot: slot.id
      };
      this.specificRescheduleData = {
        booking_id: this.bookingData.id,
        slot: slot.id,
        applicant_id: this.applicantId
      };
      this.spinner.show();
      // Calling function to Reschedule Entire Booking
      this.apiService.rescheduleEntireAppointment(this.storedData).subscribe({
        next: (response: any) => {
          if ((response.success === true)) {
            this.spinner.hide();
            this.rescheduleResponse = response;
            this.isRescheduledCompleted = true;
  
          } else {
            this.spinner.hide();
            this.snackBar.open(response.message, 'Close', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: 'error-snackbar'
            });
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.snackBar.open(err.error.message, 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'custom-snackbar-success'
          });
          this.router.navigate(['/booking-list']);
        },
        complete: () => { }
      });
    }
  }

  //Function to go to home
  homeButton() {
    this.router.navigate(['/booking-list']);
  }

  ngAfterViewInit() {
    const monthPrevBtn = document.querySelectorAll(
      '.mat-calendar-previous-button'
    );
    const monthNextBtn = document.querySelectorAll('.mat-calendar-next-button');

    if (monthPrevBtn) {
      Array.from(monthPrevBtn).forEach((button) => {
        this.renderer.listen(button, 'click', (event) => {
          this.selected = "";
          //handle month change
          const monthCount = this.myCalendar.activeDate.getMonth() + 1;
          this.getMonthSlots(monthCount);
        });
      });
    }

    if (monthNextBtn) {
      Array.from(monthNextBtn).forEach((button) => {
        this.renderer.listen(button, 'click', (event) => {
          this.selected = "";
          //handle month change
          const monthCount = this.myCalendar.activeDate.getMonth() + 1;
          this.getMonthSlots(monthCount);
        });
      });
    }
  }
  ngOnInit(): void {   
    if(this.datesToHighlight.length>0)
    this.startDate = new Date(this.datesToHighlight[0]);
  }

}
